module.exports = __webpack_public_path__ + "static/img/-v-2.5589bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-v-2.png
// module id = hkSl
// module chunks = 0